import { Cell, NonEditableCell } from '@silevis/reactgrid';
import { useTheme } from '@mui/material';
import addCell from '../helpers/addCell';
import { Week } from '../../../../../../../../../../../store/planStore';

const useAddNumberOfDaysRow = (cells: Cell[], weeks: Week[]) => {
  const theme = useTheme();

  const stableColumns = 2;

  addCell({
    cells,
    rowIndex: 2,
    colIndex: 0,
    Template: NonEditableCell,
    value: 'Number of days',
    sx: {
      background: theme.palette.grpTable.background.default,
      color: theme.palette.grpTable.text.main,
      fontWeight: 500,
      fontSize: '12px',
    },
  });
  addCell({
    cells,
    rowIndex: 2,
    colIndex: 1,
    Template: NonEditableCell,
    sx: {
      background: theme.palette.grpTable.background.default,
    },
  });
  weeks.forEach((week, index) => {
    addCell({
      cells,
      rowIndex: 2,
      colIndex: index + stableColumns,
      Template: NonEditableCell,
      value: week.numberOfDays,
      sx: {
        background: theme.palette.grpTable.background.day,
        color: theme.palette.grpTable.text.main,
        fontWeight: 700,
        fontSize: '12px',
      },
    });
  });
  addCell({
    cells,
    rowIndex: 2,
    colIndex: weeks.length + stableColumns,
    Template: NonEditableCell,
    sx: {
      background: theme.palette.grpTable.background.default,
    },
  });
};

export default useAddNumberOfDaysRow;
